import { useState } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream-50">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-16">
        <h1 className="font-heading text-4xl text-ink-900 font-light">Recuperar contraseña</h1>
        <p className="mt-3 text-ink-500">
          Escribe el correo con el que te registraste y te enviaremos un link para restablecer tu contraseña.
        </p>

        {sent ? (
          <div className="mt-10 bg-white border border-line rounded-2xl p-6 flex items-start gap-4" data-testid="forgot-success">
            <CheckCircle2 size={22} strokeWidth={1.75} className="text-sage shrink-0 mt-0.5" />
            <div>
              <h3 className="font-heading text-lg text-ink-900">Revisa tu correo</h3>
              <p className="mt-1 text-sm text-ink-500 leading-relaxed">
                Si el correo existe, te enviamos instrucciones para restablecer tu contraseña. El link vence en 1 hora.
              </p>
              <Link to="/login" className="text-coral hover:underline text-sm mt-4 inline-block" data-testid="back-to-login">
                Volver a iniciar sesión
              </Link>
            </div>
          </div>
        ) : (
          <>
            <form onSubmit={submit} className="mt-10 space-y-6" data-testid="forgot-form">
              <div className="space-y-2">
                <Label className="text-xs uppercase tracking-[0.2em] text-ink-500">Correo</Label>
                <Input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="tu@correo.com"
                  className="rounded-xl border-line focus:border-coral focus:ring-coral/20 h-12"
                  data-testid="forgot-email-input"
                />
              </div>
              <Button
                type="submit"
                disabled={loading}
                className="w-full h-12 rounded-full bg-coral hover:bg-coral-hover text-white"
                data-testid="forgot-submit-btn"
              >
                {loading ? "Enviando…" : "Enviar link"}
              </Button>
            </form>

            <p className="mt-8 text-sm text-ink-500 text-center">
              <Link to="/login" className="text-coral hover:underline" data-testid="forgot-back-login">
                Volver a iniciar sesión
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
